import { useContext } from 'react'

import { ConciliationBudgetContext } from '@provider/Budget/conciliationProvider'

import type { IBudgetConciliationContext } from '@base/@types/providers/Budget/conciliation'

export default function useConciliationBudget(): IBudgetConciliationContext {
  const context = useContext(ConciliationBudgetContext)

  return context
}
